import React from "react";
import MonthPicker from "../MonthPicker";

const PaymentsFilters = ({
    accounts,
    maxDate,
    filters,
    onChange,
    onSearch,
    onPublishPeriod,
    onDownloadAll,
    loading,
    publishing,
}) => {
    const { account, mode, dateStart, dateEnd } = filters;
    const maxYear = maxDate ? parseInt(maxDate.slice(0, 4), 10) : undefined;

    const update = (patch) => onChange({ ...filters, ...patch });

    const selectStyle = {
        background: 'transparent',
        border: 'none',
        borderBottom: '2px solid var(--ink-border-strong)',
        borderRadius: 0,
        color: 'var(--ink-text)',
        padding: '6px 2px',
        fontWeight: 600,
        fontSize: '1rem',
        outline: 'none',
        cursor: 'pointer',
        transition: 'border-color 0.2s',
    };

    return (
        <div className="card shadow-sm border-0 bg-dark mb-4">
            <div className="card-body p-3">
                <div className="row g-3 align-items-end">
                    <div className="col-md-3">
                        <label className="mb-1 d-block text-white small text-uppercase fw-bold opacity-75">Cuenta</label>
                        <select
                            className="form-control"
                            style={selectStyle}
                            value={account}
                            onChange={(e) => update({ account: e.target.value })}
                        >
                            <option value="-1" style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>Todos los clientes</option>
                            {accounts.map((acc) => (
                                <option key={acc.id_pub} value={acc.pub_name} style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>
                                    {acc.pub_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2">
                        <label className="mb-1 d-block text-white small text-uppercase fw-bold opacity-75">Periodo</label>
                        <select
                            className="form-control"
                            style={selectStyle}
                            value={mode}
                            onChange={(e) => update({ mode: e.target.value })}
                        >
                            <option value="monthly" style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>Mensual</option>
                            <option value="annual" style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>Anual</option>
                            <option value="custom" style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>Rango de fechas</option>
                        </select>
                    </div>

                    <div className="col-md-2">
                        <MonthPicker
                            label={mode === 'custom' ? 'Desde' : (mode === 'annual' ? 'Año' : 'Periodo')}
                            value={dateStart}
                            onChange={(v) => update({ dateStart: v })}
                            minYear={2013}
                            maxYear={maxYear}
                            showMonth={mode !== 'annual'}
                        />
                    </div>

                    {mode === 'custom' && (
                        <div className="col-md-2">
                            <MonthPicker
                                label="Hasta"
                                value={dateEnd}
                                onChange={(v) => update({ dateEnd: v })}
                                minYear={2013}
                                maxYear={maxYear}
                            />
                        </div>
                    )}

                    <div className="col-md-5 d-flex gap-2 justify-content-end">
                        <button
                            className="btn btn-ink-search"
                            onClick={onSearch}
                            disabled={loading}
                        >
                            {loading ? 'Cargando...' : 'Mostrar datos'}
                        </button>
                        <button
                            className="btn btn-success"
                            onClick={onPublishPeriod}
                            disabled={publishing || loading}
                        >
                            {publishing ? 'Publicando...' : 'Publicar periodo'}
                        </button>
                        <button
                            className="btn btn-outline-secondary"
                            onClick={onDownloadAll}
                            disabled={loading}
                            title="Descargar xls de todas las cuentas"
                        >
                            xls
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentsFilters;